import {createFileRoute, redirect, useRouterState} from '@tanstack/react-router'
import {useContext} from "react";
import {RecordingsContext} from "../../context/RecordingsContext.tsx";
import {isAuthenticated} from "../../utils/auth.ts";
import Layout, {NoItems} from "../../components/Layouts/Layout.tsx";
import SessionRow from "../../components/Sessions/SessionRow.tsx";

export const Route = createFileRoute('/sessions/')({
  beforeLoad: async () => {
    if(!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: SessionsIndex,
})

function SessionsIndex() {
  
  const router = useRouterState();
  const {recordings} = useContext(RecordingsContext);
  
  return (
    <Layout>
      <div className={'bg-white xs:hidden w-0 block w-screen h-full px-4 pt-6 relative'}>
        <h3 className={'text-2xl font-bold mb-2'}>Sessions</h3>
        {!!recordings && recordings.length > 0 &&
          <p className={'text-neutral-500 text-sm'}>
            {`${recordings.length} ${recordings.length === 1 ? 'session' : 'sessions'}`}
          </p>
        }
        {!recordings || recordings.length === 0 && <NoItems/>}
        {!!recordings && recordings.length > 0 &&
          <ul
            className={'h-[calc(100%-7rem)] w-full overflow-auto flex flex-col items-start justify-start gap-1 mt-3 pt-3 scroller--blurred-container'}>
            {recordings.map(session => <SessionRow key={session.id} session={session} active={router.location.pathname === `/sessions/${session.id}`}/>)}
          </ul>
        }
      </div>
    </Layout>
  )
}
